import React from "react";
import * as localforage from "localforage";
import * as $ from "jquery";
import "datatables.net";
import "datetime-moment";
import "../css/dataTable.css";
import { url } from "../apis/apiSetup";
import { language } from "./datatableSetting";
import { IconButton } from "@material-ui/core";
import { DeleteOutlined } from "@material-ui/icons";
import { searchStyleRender } from "./datatableSearchIconRender";
import { deleteCompanyGroupAPI } from "../apis/deleteCompanyGroupAPI";
import EditGroupNameInput from "../components/devicesGroups/EditGroupNameInput";
import { errorHandling } from "./errorHandling";
import { ReactRender } from "@/components/ReactRender";

export const table = async t => {
  const token = await localforage.getItem("token");
  const company_id = await localforage.getItem("userCompanyID");

  $("#edit-groups-table").DataTable({
    serverSide: true,
    processing: true,
    language: language(t),
    searching: true,
    filter: false,
    deferRender: true,
    info: false,
    autoWidth: false,
    stateSave: false,
    destroy: true,
    scrollY: "calc( 90vh - 410px )",
    paging: false,
    ordering: true,
    order: [[0, "asc"]],
    ajax: {
      url: `${url}/api/v1/company/groups`,
      type: "GET",
      dataSrc: "data",
      data: {
        company_id: company_id
      },
      beforeSend: request => {
        request.setRequestHeader("Authorization", "Bearer " + token);
        request.setRequestHeader("Accept", "application/json");
      },
      error: (xhr, status, error) => {
        errorHandling(error);
      }
    },
    columns: [
      {
        data: "name",
        name: "name",
        title: `${t("table.groupName")}`,
        searchable: true,
        orderDataType: "dom-text",
        type: "string",
        createdCell: (td, data, rowData) => {
          ReactRender(
            <EditGroupNameInput id={rowData.id} inputValue={data} />,
            td
          );
        }
      },
      {
        data: "id",
        title: `${t("setting.actions")}`,
        className: "action",
        searchable: false,
        createdCell: (td, data) => {
          ReactRender(
            <IconButton
              aria-label="delete"
              onClick={() => deleteCompanyGroup(t, data)}
            >
              <DeleteOutlined color="secondary" />
            </IconButton>,
            td
          );
        }
      }
    ]
  });

  searchStyleRender();
};

// var table = $('#edit-groups-table').DataTable();

export const deleteCompanyGroup = async (t, id) => {
  await deleteCompanyGroupAPI(id);
  table(t);
};
